import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import uploadImagetow from '@/components/uploadImagetow'; // 使用禁言共用模块

import addAbuse from "./components/addAbuse.vue";
import { reportList } from "@/api/gmtool/packageCode";
import { gmTool, serchSelect } from "@/mixins/index";
export default {
  name: "reportAbuse",
  components: {
    addAbuse: addAbuse
  },
  mixins: [gmTool, serchSelect],
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      total: 0,
      paramsData: {
        page: 1,
        server_id: [],
        report_user_id: '',
        report_role_id: '',
        reported_user_id: '',
        reported_role_id: '',
        report_type: ''
      },
      reportTypeList: [{
        label: this.$t('insultDiscrimination'),
        value: 1
      }, {
        label: this.$t('adFlooding'),
        value: 2
      }, {
        label: this.$t('badMessagePornGamblingDrug'),
        value: 3
      }, {
        label: this.$t('illegalMessageReactionary'),
        value: 4
      }, {
        label: this.$t('otherLabel'),
        value: 5
      }],
      reportTypeMap: {
        '1': this.$t('insultDiscrimination'),
        '2': this.$t('adFlooding'),
        '3': this.$t('badMessagePornGamblingDrug'),
        '4': this.$t('illegalMessageReactionary'),
        '5': this.$t('otherLabel')
      }
    };
  },
  created: function created() {
    this.Renewal(); // this.getList()
  },
  activated: function activated() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList();

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    getList: function getList(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.paramsData.page = e;
                _this2.reqLoading = true;
                params = JSON.parse(JSON.stringify(_this2.paramsData));
                params.game_id = _this2.rawData.game_id;
                reportList(params).then(function (res) {
                  if (res.status == 200) {
                    _this2.tableData = res.data.data;

                    _this2.tableData.forEach(function (item) {
                      var foundData = _this2.serverLists.find(function (b) {
                        return b.serverID == item.server_id;
                      });

                      item.server_name = foundData ? foundData.serverName : '/';
                    });

                    _this2.total = res.data.total;
                  }
                }).finally(function () {
                  _this2.reqLoading = false;
                });

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    Renewal: function Renewal() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.paramsData.server_id = [];
                _context3.next = 3;
                return _this3.getserverList();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};